import { Grid } from "@mui/material";
import NotificationConfigurationTable from "../Components/Settings/NotificationConfigurationTable";
import genericStyles from "../Styles/genericStyles.module.css";

export default function NotificationConfiguration() {
  return (
    <div className={genericStyles.mainContainer}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <NotificationConfigurationTable />
        </Grid>
      </Grid>
    </div>
  );
}
